<template>
  <div id="tabular-view">
    <div class="content-wrapper">
      <div class="content">
        <NodeViewer :node="{parent: 0, id: 0, title: mapStore.state.map.title}"/>
        <NodeViewer v-for="node in mapStore.state.nodePath" :node="node" :key="node.id"/>
        <DefAndGuideList v-if="mapStore.state.defGuide" />
        <div class="spacer"></div>
        <DataViewerContainer />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, inject, ref} from "vue"
import NodeList from "@/components/NodeList.vue";
import NodeViewer from "@/components/NodeViewer.vue";
import DefAndGuideList from "@/components/DefAndGuideList.vue";
import DataViewer from "@/components/DataViewer.vue";
import {useMapStore} from "@/mixins/mapStore";
import DataViewerContainer from "@/components/DataViewerContainer.vue";

export default defineComponent({
  name: "TabularView",
  components: {DataViewerContainer, DefAndGuideList, NodeViewer, NodeList, DataViewer},
  emits: {
    "mode:graph": () => true,
  },

  setup() {
    const mapStore = useMapStore()
    const color = ref("red")
    return {
      mapStore
    }
  }
})
</script>
<style lang="scss">
@import "src/assets/styles/vars";

#tabular-view {
  height: 95vh;
  display: flex;
  flex-direction: column;


  .content-wrapper {
    flex-grow: 1;
    display: flex;

    .content {
      flex-grow: 1;
      width: 0;
      display: flex;
      overflow: scroll;
    }


  }
}
</style>